import { render, staticRenderFns } from "./eu-ES.vue?vue&type=template&id=582e1baa&scoped=true&"
var script = {}
import style0 from "./eu-ES.vue?vue&type=style&index=0&id=582e1baa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "582e1baa",
  null
  
)

export default component.exports